import React from "react";
import moment from 'moment'

const SettingsCard = (props) => {
  const account = props.account
  const macroData = props.macroData
  const movingCarbs = Math.round(macroData.carbs)
  const movingFat = Math.round(macroData.fat)

  const getProteinBoost = (proteinLevel) => {
    return (proteinLevel / 100) * 0.5 * account.user.weight
  }

  const formatFatCarbSlider = (setting) => {
    const labels = {
      LOW: '20%',
      P25: '25%',
      MED: '30%',
      P35: '35%',
      HIGH: '40%'
    }
    return labels[setting]
  }

  const getMovingTargetDate = () => {
    let usingMovingTargets = macroData.movingTargets
    let startDate
    for(let i = account.user.macroAdjustments.length - 1; i >= 0; i--) {
      if(usingMovingTargets === account.user.macroAdjustments[i].moving_targets) {
        startDate = moment.utc(account.user.macroAdjustments[i].adjustment_date).format('YYYY-MM-DD')
      }
    }
    return startDate
  }

  return (
    <div className="avn-widget">
      <div className="account-content-container">
        <div className='account-content right'>
          <h3>Preferences</h3>
          <p><span>Vegan:</span>{(account.user.vegetarian === 1) ? 'Yes' : 'No'}</p>
          <p><span>Extra Protein Level:</span>+{Math.round(getProteinBoost(account.user.extra_protein_level))}g</p>
          <p><span>Daily Macro Adjustments:</span>{(macroData.movingTargets === 2) ? 'Dispersed' : ((macroData.movingTargets === 1) ? 'Aggressive' : 'Off')}</p>
          {(macroData.movingTargets === 1) &&
              <div>
              <p><span>Start Date:</span>{getMovingTargetDate()}</p>
              <p><span>Moving Carbs:</span>{movingCarbs}g</p>
              <p><span>Moving Fat:</span>{movingFat}g</p>
              </div>
          }
          <p><span>Fat/Carb Slider:</span>{formatFatCarbSlider(account.user.fat_content)}</p>
          <p><span>Daily Weigh-in Enabled:</span>{(account.user.daily_weigh_in_enabled === 1) ? 'Yes' : 'No'}</p>
        </div>
      </div>
    </div>
  );
};

export default SettingsCard;
